export const REQUEST_INVITES_FETCH_EM = "REQUEST_INVITES_FETCH_EM"
export const FETCH_INVITES_EM_SUCCESS = "FETCH_INVITES_EM_SUCCESS"
export const FETCH_INVITES_EM_FAILURE = "FETCH_INVITES_EM_FAILURE"

export const CLEAR_FETCH_INVITES_EM_STATES = "CLEAR_FETCH_INVITES_EM_STATES"